// the width of one bar (i.e. 32 steps at xScale=1)
export const DEFAULT_WIDTH = 100; // in pixels...

// 100 / 16 = 1 1/16th note which is the size of one step in piano roll at xScale=1 here
// But in piano roll xScale=1 1/16th note is 36th

export function getBarWidth(width, resolution, xScale=1 ) {
    let ratio = resolution.resolution / 8;
    let ret = xScale * ratio * width / 32 * DEFAULT_WIDTH;
    return ret;
}
